/**
 * @fileoverview Formatos da tela do Multi unidades, usados pelos cartões, pela
 * tabela e pelo modal de cada quadro — um formato só para o mesmo número.
 */

// "2026-09-11" -> "11/09"
export const dayMonth = ymd =>
  ymd && ymd.length >= 10 ? ymd.slice(8, 10) + "/" + ymd.slice(5, 7) : "";

/** Duração em segundos, curta: "45s", "12min", "3h20min"; vazio ou zero = "—". */
export const secToShort = sec => {
  if (sec == null || sec <= 0) return "—";
  const s = Math.round(sec);
  if (s < 60) return s + "s";
  const m = Math.floor(s / 60);
  if (m < 60) return m + "min";
  const h = Math.floor(m / 60);
  const r = m - h * 60;
  return r === 0 ? h + "h" : h + "h" + r + "min";
};

export const fmtNumberPtBR = n => {
  if (n == null) return "—";
  return Number(n).toLocaleString("pt-BR");
};

/** ART em minutos: "45s", "12.7min", "1h30min". */
export const formatARTMinutes = m => {
  if (m == null || Number.isNaN(m)) return "—";
  if (m < 1) return Math.round(m * 60) + "s";
  if (m < 60) return Math.round(m * 10) / 10 + "min";
  const h = Math.floor(m / 60);
  const rest = Math.round(m - h * 60);
  return rest === 0 ? h + "h" : h + "h" + rest + "min";
};

/** Situação do ticket, como o atendente a vê. */
export const STATUS_LABEL = { open: "Aberto", pending: "Pendente", closed: "Resolvido" };

const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/** "2026-10" → "out/2026"; "2026-10-28" → "28/10". */
export const fmtPeriod = key => {
  if (!key) return "";
  if (key.length === 7) return MONTHS[Number(key.slice(5, 7)) - 1] + "/" + key.slice(0, 4);
  return dayMonth(key);
};

/** Props de um quadro clicável (mouse e teclado) que abre o modal dele. */
export const openableProps = onOpen => ({
  role: "button",
  tabIndex: 0,
  title: "Ver o que está por trás deste número",
  onClick: onOpen,
  onKeyDown: e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onOpen();
    }
  }
});
